import { Box, Flex, Text } from "@shared/primitive-components"
import { localDateTimeToString } from "@shared/utils/formatters/dates"
import { formatPercentage } from "@shared/utils/formatters/formatPercentage"
import { SpeedingBreakdown } from ".."
import { reduceDateByOneHour } from "../../../../utils"
import { speedingStyles as styles } from "../../../styles"
import { SpeedingComponentProps } from "../../../types"

export const SpeedingDetails = ({ activePeriod, periods }: Omit<SpeedingComponentProps, "setActivePeriod">) => {
  const period = periods.find((p) => p.number === activePeriod?.number)
  if (!period?.analytics) return null
  const totalSpeedingPercentage = period.analytics.distanceSpentSpeeding ?? 0

  return (
    <Box>
      <Flex flexDirection="column" css={styles.speedingOverview}>
        <Box>
          <Text use="body2" css={styles.speedingDate}>
            {localDateTimeToString(period.startedAt, `en`, `dd MMM yyyy`)} -{` `}
            {localDateTimeToString(reduceDateByOneHour(period.endedAt), `en`, `dd MMM yyyy`)}
          </Text>
          <Text use="headline2" tag="h2" css={styles.speedingPercentage}>
            {totalSpeedingPercentage > 0
              ? formatPercentage(totalSpeedingPercentage, 1)
              : formatPercentage(totalSpeedingPercentage)}
          </Text>
          <Text use="body2" css={styles.speedingLabel}>
            of your fleet&apos;s total miles during this month were spent speeding
          </Text>
        </Box>
        {totalSpeedingPercentage > 0 && (
          <Box>
            <Text use="headline2" tag="h4" css={styles.speedingHeading}>
              Speeding Breakdown
            </Text>
            <SpeedingBreakdown speedBands={period.analytics.speedBands} extended />
          </Box>
        )}
      </Flex>
    </Box>
  )
}
